import {RouterGuard} from '@/models/Router/RouterGuard'

export const GuestGuard: RouterGuard = {
  canAccess: () => true,
  redirectTo: () => undefined
}
